import { OrdersDto } from '../types';
import { IOrderApi } from './Interface/IOrderApi';
import { ApiService } from '@/services/ApiService';

export default class OrderApi extends ApiService implements IOrderApi {
    async getOrders(take: number, skip: number, language: string): Promise<OrdersDto | undefined> {
        return await this.httpGet<OrdersDto>(`/api/webshop/v1.0/orders?take=${take}&skip=${skip}`, {
            headers: { 'accept-language': language }
        });
    }
}
